export const datePickerPt = {
  root: 'pv-datepicker',
  day: 'pv-datepicker-day',
  tableHeaderCell: 'pv-datepicker-weekday-cell',
  hour: 'pv-datepicker-hour',
  minute: 'pv-datepicker-minute',
  second: 'pv-datepicker-second',
  pcIncrementButton: { root: 'pv-datepicker-navigation-button' },
  pcDecrementButton: { root: 'pv-datepicker-navigation-button' },
  pcPrevButton: { root: 'pv-datepicker-navigation-button' },
  pcNextButton: { root: 'pv-datepicker-navigation-button' },
  pcInputText: { root: 'pv-datepicker-input' }
};